import { FC } from "react";
import { Button, Link, Stack, Text } from "@chakra-ui/react";

import { VITE_SUPPORT_EMAIL_ADDRESS } from "../../../../ENV.ts";

interface Props {
  onClose: () => void;
}

export const OverpaymentInfoModal: FC<Props> = ({ onClose }) => {
  const email = VITE_SUPPORT_EMAIL_ADDRESS ?? "";

  return (
    <Stack
      spacing="10px"
      px="12px"
      fontSize="13px"
      lineHeight="19px"
    >
      <Text>
        <Text variant="brand" display="inline">Аванс</Text>
        {" "}
        будет сохранён и спишется в дату платежа по графику.
      </Text>

      <Text>
        <Text variant="brand" display="inline">Переплала</Text>
        {" "}
        будет автоматически списана в счёт возможной задолженности в будущем.
      </Text>

      <Text>
        Вы можете заявить о возврате в поддержку
        {" "}
        <Link
          href={`mailto:${email}`}
          color="#3B82F6"
          textUnderlineOffset="2px"
        >
          {email}
        </Link>
      </Text>

      <Button onClick={onClose} mt="20px" w="100%">Понятно</Button>
    </Stack>
  );
};
